<template>
  <div>
      <template v-if="footer.tipo == 1">
          <LayoutSports></LayoutSports>
      </template>
      <template v-if="footer.tipo == 2">
          <LayoutTeatros></LayoutTeatros>
      </template>
  </div>
</template>

<script>
import LayoutSports from './layouts/index/Sports';
import LayoutTeatros from './layouts/index/Teatros';

export default {
    head: {
        title: function() {
            return {
                inner: 'Eventos',
                complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
            }
        },
        meta: function() {
            return [
                {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
            ]                
        },
    },    
    components: {
        LayoutSports,
        LayoutTeatros
    },
    computed : {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        footer() {
            return this.$store.getters.getFooter;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    created() {
        if(!this.footer.partidos) {
            this.$router.push({ name: 'front.home'});
        }
    }
}
</script>
